import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import LoginLayout from "@/pages/Layout/LoginLayout.vue";

import Home from "@/pages/Home.vue";
import UserProfile from "@/pages/UserProfile.vue";
import NewMemry from "@/pages/NewMemry.vue";
import Memries from "@/pages/Memries.vue";
import MemryTree from "@/pages/MemryTree.vue";
import Drafts from "@/pages/Drafts.vue";
import Typography from "@/pages/Typography.vue";
import ManageTags from "@/pages/ManageTags.vue";
import Info from "@/pages/Info.vue";

import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
     {
        path: "dashboard",
        name: "Dashboard",
        component: Home
      },
      {
        path: "newmemry",
        name: "New Memry",
        props: true,
        component: NewMemry
      },
      {
        path: "memry/:id",
        name: "Update Memry",
        props: true,
        component: NewMemry
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile
      },
      {
        path: "memries",
        name: "All Memries",
        component: Memries
      },
      {
        path: "memrytree",
        name: "Memry Tree",
        component: MemryTree
      },
      {
        path: "drafts",
        name: "Drafts",
        component: Drafts
      },
      {
        path: "tags",
        name: "Tags",
        component: ManageTags
      },
      {
        path: "typography",
        name: "Typography",
        component: Typography
      },
      {
        path: "icons",
        name: "Icons",
        component: Icons
      },
      {
        path: "maps",
        name: "Maps",
        meta: {
          hideFooter: true
        },
        component: Maps
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications
      },
      {
        path: "upgrade",
        name: "Upgrade to PRO",
        component: UpgradeToPRO
      }
    ]
  },

  {
    path: "/login",
    name: "Login",
    component: LoginLayout
  },
  {
    path: "/logout",
    name: "Logout",
    component: LoginLayout
  },
  {
    path: "/info",
    name: "Info",
    component: Info
  },
  {
    path: "/register",
    name: "Register",
    component: LoginLayout
  }
];

export default routes;
